// extracted by mini-css-extract-plugin
export var active = "_ug-1";
export var circle = "_ug-0";
export var completed = "_ug-2";
export var connector = "_ug-4";
export var connectorCompleted = "_ug-7";
export var connectorSpacer = "_ug-5";
export var iconStrokeOverride = "_ug-8";
export var labelContainer = "_ug-6";
export var pending = "_ug-3";